export const model = {
    fields: {
        amount: {
            isRequired: true
        },
        productId: {
            isRequired: true
        },
        basisId: {
            isRequired: true
        },
        code: {
            isRequired: true
        }
    }
}